var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"color":"#868686","width":"100%","border":"8px solid #f8fafc","border-radius":"6px","padding":"10px","line-height":"20px"}},[_c('el-icon',{staticClass:"el-icon-warning-outline"}),_c('span',[_vm._v(" "+_vm._s(_vm.item.options))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }